import { t, Trans } from '@lingui/macro';

import Panel from '../../page-framework/panel/PanelDecorator';
import {
    PANEL_CATEGORIES,
    LINE_CHART_PANEL_PREVIEW_IMAGE,
    PANEL_PRIORITIES,
} from '../../page-framework/panel/PanelRegistry';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import usePanelDataService from '../../../services/PanelDataService';
import SiteWan from './SiteWan';
import { siteFilterId, timeRangeFilterId } from '../../filters';
import MessageOverlay from '../../charts/message-overlay/MessageOverlay';
import { useId } from '../../page-framework/panel/Panel';

const title = t`Site WAN`;

const siteWanDataSource = {
    url: '/query/table',
    params: {
        type: 'site',
        metrics: [
            'status',
            'siteLatencyStatus',
            'statusInterfaceUtil',
            'siteLatencyCounts',
            'statusInterfaceErrors',
            'statusInterfaceDiscards',
        ],
        renderAsEntity: true,
        trends: [
            'status',
            'latency',
            'inBitsPerSec',
            'outBitsPerSec',
            'inNetworkUtil',
            'outNetworkUtil',
            'siteErrorsIn',
            'siteErrorsOut',
            'siteErrorRateInPerc',
            'siteErrorRateOutPerc',
            'siteDiscardsIn',
            'siteDiscardsOut',
            'siteDiscardRateInPerc',
            'siteDiscardRateOutPerc',
        ],
    },
};

function SiteWanPanel() {
    const id = useId();
    const siteWanData = usePanelDataService(siteWanDataSource);
    const data = siteWanData?.data?.[0];

    if (!data || !data.site?.hasWANInterfaces) {
        return <MessageOverlay message={<Trans>No data available</Trans>} />;
    }

    return <SiteWan id={id} data={data} />;
}

SiteWanPanel.propTypes = panelPropTypes;

SiteWanPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    contentHeight: 420,
    minContentHeight: 420,
    disableVerticalResize: true,
};

export default Panel({
    typeAlias: 'SiteInfrastructure',
    catalogEntry: {
        category: PANEL_CATEGORIES.SITE,
        priority: PANEL_PRIORITIES.CHART,
        title,
        description: t`Latency, utilization, and discards/errors trend for a selected site's WAN interfaces`,
        previewImage: LINE_CHART_PANEL_PREVIEW_IMAGE,
        ipm: true,
    },
    filters: {
        required: [timeRangeFilterId, siteFilterId],
        optional: [],
    },
})(SiteWanPanel);
